import * as React from "react"
import { ChevronDown } from "lucide-react"
import { cn } from "../../lib/utils"

/**
 * Composant Select natif HTML personnalisé
 * Remplace les Select Radix UI problématiques avec une solution native fiable
 * 
 * Usage simple:
 * <SimpleNativeSelect
 *   value={value}
 *   onValueChange={setValue}
 *   options={[{value: 'opt1', label: 'Option 1'}, ...]}
 *   placeholder="Choisir..."
 * />
 */

export const SimpleNativeSelect = React.forwardRef(({ 
  value, 
  onValueChange, 
  options = [], 
  placeholder = "Sélectionner...",
  className,
  disabled = false,
  ...props 
}, ref) => {
  return (
    <div className="relative w-full">
      <select
        ref={ref}
        value={value || ''}
        onChange={(e) => onValueChange && onValueChange(e.target.value)}
        disabled={disabled}
        className={cn(
          "flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-white px-3 py-2 text-sm shadow-sm ring-offset-background",
          "focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "appearance-none cursor-pointer transition-all duration-75",
          "hover:border-gray-400 active:border-ring",
          "pr-8", // Espace pour l'icône
          !value && "text-muted-foreground",
          className
        )}
        {...props}
      >
        {placeholder && <option value="" disabled>{placeholder}</option>}
        {options.map(option => (
          <option 
            key={option.value} 
            value={option.value} 
            disabled={option.disabled}
            className="py-2 px-3"
          >
            {option.label}
          </option>
        ))}
      </select>
      <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
        <ChevronDown className="h-4 w-4 opacity-50 text-gray-500" />
      </div>
    </div>
  )
})
SimpleNativeSelect.displayName = "SimpleNativeSelect"
